import { Component, OnInit } from '@angular/core';
import { AdviceService } from '../services/advice.service';

@Component({
  selector: 'app-help-long',
  templateUrl: './help-long.component.html',
  styleUrls: ['./help-long.component.css']
})
export class HelpLongComponent implements OnInit {

  constructor(private adviceService: AdviceService) { }

  ngOnInit() {
  }

}
